import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { api, mediaUrl } from "../../lib/api";

export const refreshTmdbMatches = () => window.dispatchEvent(new Event("rp:tmdb-matches"));

export const TmdbMatchBanner = () => {
  const [items, setItems] = useState([]);
  const { pathname } = useLocation();

  const load = () => api.get("/admin/manual-releases/suggestions").then((r) => setItems(r.data.items)).catch(() => {});
  useEffect(() => { load(); }, [pathname]);
  useEffect(() => {
    window.addEventListener("rp:tmdb-matches", load);
    return () => window.removeEventListener("rp:tmdb-matches", load);
  }, []);

  const link = async (m, c) => {
    try {
      const { data } = await api.post(`/admin/manual-releases/${m.tmdb_id}/link`, { tmdb_id: c.tmdb_id });
      toast.success(data.action === "merged" ? `« ${m.title} » fusionnée avec la fiche TMDB` : `« ${m.title} » reliée à TMDB`);
      load();
      window.dispatchEvent(new Event("rp:manual-releases-changed"));
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Liaison impossible");
    }
  };
  const dismiss = async (m, c) => {
    await api.post(`/admin/manual-releases/${m.tmdb_id}/dismiss-suggestion`, { tmdb_id: c.tmdb_id });
    load();
  };

  if (!items.length) return null;
  return (
    <div className="mb-8 border border-[var(--red)] bg-[var(--red-soft)] rounded-md p-4 space-y-3" data-testid="tmdb-match-banner">
      <div className="flex items-center gap-2 text-sm font-medium text-[var(--red)]">
        <Sparkles className="h-4 w-4" />
        {items.length === 1 ? "Une sortie manuelle a trouvé sa fiche TMDB" : `${items.length} sorties manuelles ont trouvé leur fiche TMDB`}
      </div>
      {items.flatMap((m) =>
        m.tmdb_suggestions.map((c) => (
          <div key={`${m.tmdb_id}-${c.tmdb_id}`} className="flex flex-wrap items-center gap-3 bg-white rounded-sm p-2.5" data-testid={`tmdb-match-${m.tmdb_id}-${c.tmdb_id}`}>
            <img src={mediaUrl(m.poster_url)} alt="" className="h-12 w-8 object-cover rounded-sm" />
            <span className="text-neutral-400 text-xs">→</span>
            {c.poster_url ? <img src={c.poster_url} alt="" className="h-12 w-8 object-cover rounded-sm" /> : <div className="h-12 w-8 bg-neutral-200 rounded-sm" />}
            <div className="flex-1 min-w-[180px] text-sm">
              <div><b>{m.title}</b> <span className="text-neutral-500">({m.type})</span></div>
              <div className="text-xs text-neutral-500">Fiche TMDB « {c.title} » · {c.date || "date inconnue"} · n° {c.tmdb_id}</div>
            </div>
            <button className="btn-red" onClick={() => link(m, c)} data-testid={`tmdb-match-link-${m.tmdb_id}-${c.tmdb_id}`}>Relier</button>
            <button className="btn-ghost" onClick={() => dismiss(m, c)} data-testid={`tmdb-match-dismiss-${m.tmdb_id}-${c.tmdb_id}`}>Ce n'est pas elle</button>
          </div>
        ))
      )}
    </div>
  );
};
